export const MEDIA_TILE_GAP = 8;
export const MEDIA_TILES_PER_ROW = 3;
